export default __webpack_public_path__ + "static/media/principal-banner-mobile.ba26db6b.png";